import { faFileCsv, faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton, Stack, Theme, Tooltip, useTheme } from '@mui/material';
import React from 'react';
import { exportToCSV, exportToExcel, prepareDataForExport } from './exportUtils';

interface ExportButtonsProps {
    data: any[];
    componentType: string;
    filename: string;
}

/**
 * Reusable export buttons component
 * @param {ExportButtonsProps} props - Component props
 * @returns {JSX.Element} - Rendered component
 */
const ExportButtons: React.FC<ExportButtonsProps> = ({ data, componentType, filename }) => {
    const theme: Theme = useTheme();

    // Handle CSV export
    const handleCSVExport = () => {
        const preparedData = prepareDataForExport(data, componentType);
        exportToCSV(preparedData, `${filename}_${new Date().toISOString().split('T')[0]}`);
    };

    // Handle Excel export
    const handleExcelExport = () => {
        const preparedData = prepareDataForExport(data, componentType);
        exportToExcel(preparedData, `${filename}_${new Date().toISOString().split('T')[0]}`, filename);
    };

    return (
        <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            justifyContent="flex-end"
            // not visible on print
            sx={{ '@media print': { display: 'none' } }}
        >
            <Tooltip title="Export to CSV">
                <IconButton color="secondary" onClick={handleCSVExport} size="small" disabled={!data || data.length === 0}>
                    <FontAwesomeIcon
                        icon={faFileCsv}
                        size="2x"
                        color={!data || data.length === 0 ? theme.palette.text.disabled : theme.palette.info.main}
                    />
                </IconButton>
            </Tooltip>
            <Tooltip title="Export to Excel">
                <IconButton color="success" onClick={handleExcelExport} size="small" disabled={!data || data.length === 0}>
                    <FontAwesomeIcon
                        icon={faFileExcel}
                        size="2x"
                        color={!data || data.length === 0 ? theme.palette.text.disabled : theme.palette.info.main}
                    />
                </IconButton>
            </Tooltip>
        </Stack>
    );
};

export default ExportButtons;
